import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { useTab } from '@atlaskit/tabs';
import { token } from '@atlaskit/tokens';

const baseStyles = xcss({
	alignItems: 'center',
	background: token('color.background.neutral'),
	border: `${token('border.width')} solid transparent`,
	borderRadius: 'radius.full',
	gap: 'space.100',
	paddingTop: 'space.075',
	paddingBottom: 'space.075',
	paddingInline: 'space.150',
});

const selectedStyles = xcss({
	alignItems: 'center',
	background: token('color.background.selected'),
	border: `${token('border.width')} solid ${token('color.border.selected')}`,
	borderRadius: 'radius.full',
	color: 'color.text.selected',
	gap: 'space.100',
	paddingTop: 'space.075',
	paddingBottom: 'space.075',
	paddingInline: 'space.150',
});

type PillTabProps = { label: string };

export const PillTab = ({ label }: PillTabProps) => {
	const tabAttributes = useTab();

	const isTabSelected = tabAttributes['aria-selected'];
	const { 'aria-controls': ariaControls, ...tabAttributesWithoutControls } = tabAttributes;

	return (
		<Box xcss={isTabSelected ? selectedStyles : baseStyles} {...tabAttributesWithoutControls}>
			{label}
		</Box>
	);
};
